import AboutSecOne from "../components/AboutSecOne";

const AboutUs = () => {
    return (
        <>
            <AboutSecOne/>
        </>
    );
};

export default AboutUs;